import React from 'react';
import CallCenter from '../components/call-center/CallCenter';
import Header from '../components/header/Header';
import WsWrapper from '../components/dialer/WsWrapper';

const Main = () => {
  return (
    <div className="main">
      <WsWrapper>
        <Header />
        <div className="container">
          <div className="main__content">
            <CallCenter />
          </div>
        </div>
      </WsWrapper>
    </div>
  );
};

export default Main;
